<template>
  <div id="app">
    <div class="notifications">
      <b-alert
        v-for="(item, index) in notifications.messages"
        :key="index"
        :variant="notificationTypes[notifications.type]"
        dismissible
        show
        @dismissed="dismiss"
      >
        <span v-if="item">{{ item.message || item }}</span>
        <div v-if="item === 'メールが確認できません'">
          <b-link :to="{name: 'email-verification'}">
            If you didn't receive your verification
          </b-link>
        </div>
      </b-alert>
    </div>
    <Header />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import {SET_NOTIFICATION, USER_REQUEST} from "./store/constant";
import { mapGetters } from "vuex";

export default {
  name: 'App',
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      notificationTypes: {
        error: 'danger',
        success: 'success',
        info: 'primary',
      }
    }
  },
  computed: {
    ...mapGetters(['notifications'])
  },
  created: function() {
    if (this.$store.getters.isAuthenticated) {
      this.$store.dispatch(USER_REQUEST);
    }
  },
  methods: {
    dismiss() {
      this.$store.commit(SET_NOTIFICATION,{ type: null, messages: [] });
    }
  },
}
</script>

<style>
#app {
  font-family: 'Noto Sans JP', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
